// Preloads the hero scrub video into memory (blob URL). Scroll-scrubbing
// seeks dozens of times per second; streaming the file from the network makes
// the first visit stutter or freeze until the file is cached. Fetching it
// fully up-front makes every seek instant — and the same cached promise lets
// the site Loader hold until the hero is actually ready to play.
const SCRUB_SRC = "/brochure-scrub.mp4";

let scrubPromise = null;

export function preloadHeroScrub() {
  if (!scrubPromise) {
    scrubPromise = fetch(SCRUB_SRC)
      .then((res) => {
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        return res.blob();
      })
      .then((blob) => URL.createObjectURL(blob))
      // If the fetch fails, fall back to streaming straight from the server.
      .catch(() => SCRUB_SRC);
  }
  return scrubPromise;
}
